/**
 * Configured Axios Instance
 *
 * Provides a pre-configured axios instance with:
 * - Base URL pointing to backend API
 * - Automatic JWT token injection
 * - Request/response interceptors
 */

import axios from 'axios';
import { installRefreshOn401 } from './sessionRefresh';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api/v1',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// V17.534 (RBAC 2A): a 401 renews the access token once and re-sends once (sessionRefresh).
installRefreshOn401(axiosInstance);

// Request interceptor - add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle common errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - clear token and redirect to login
      console.error('Authentication failed - redirecting to login');
      localStorage.removeItem('access_token');
      localStorage.removeItem('current_user');

      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
